var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { TableCell } from './DataTableComponents';
/**
 * This component is the rendered cell of an DataTable. It is generated based on the data and
 * the Column being used as a children of the component
 */
export function Cell(_a) {
    var cellRenderer = _a.cellRenderer, dataKey = _a.dataKey, item = _a.item, index = _a.index, truncatesText = _a.truncatesText, width = _a.width, lss = _a.lss, onClick = _a.onClick, _b = _a.isClickable, isClickable = _b === void 0 ? true : _b, isClickableRow = _a.isClickableRow;
    return (React.createElement(TableCell, { lss: __assign({ width: width, cursor: isClickable && isClickableRow ? 'pointer' : undefined }, lss), truncatesText: truncatesText, onClick: function () { return isClickable && onClick(); } }, typeof cellRenderer === 'function'
        ? cellRenderer(item[dataKey], item, index)
        : item[dataKey]));
}
//# sourceMappingURL=Cell.js.map